export const StationDc = () => {
    return (
        <svg width="28" height="38" viewBox="0 0 28 38" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M14 0C6.26804 0 0 6.26801 0 14C0 16.5858 0.506124 19.2565 1.95854 21.1814L14 37.1399L26.0415 21.1814C27.3607 19.433 28 16.3422 28 14C28 6.26801 21.732 0 14 0Z" fill="#EA6035" />
            <path d="M18.6628 15.7915H14.3207L17.277 7.93872H12.1958L9.42426 17.6392H13.3968L11.272 26.4158L18.6628 15.7915Z" fill="#F1F614" />
        </svg>
    );
}